// ============================================================
// globalColors.ts —— 站点全局颜色（编辑站「全局配置 → 颜色」）的读取
//
// 颜色由编辑站保存进 globalConfig.colors（如 bgColor/headingColor/...），
// 页面壳 .site-page 的背景色取这里的 bgColor，未配置时回落白色。
// ============================================================

// 页面背景色的兜底值，与编辑站 GlobalConfigPanel 中 bgColor 的 fallback 保持一致
export const DEFAULT_GLOBAL_BG_COLOR = '#ffffff'

type GlobalColorSource = {
  colors?: Record<string, unknown>;
  bgColor?: unknown;
  pageBgColor?: unknown;
};

const normalizeColor = (value: unknown): string => (typeof value === 'string' ? value.trim() : '');

/**
 * 读取编辑站配置的页面背景色。
 * 优先 colors.bgColor，其次 colors.pageBgColor（历史字段），
 * 再兼容旧数据里 globalConfig 直接扁平存放 bgColor/pageBgColor 的情况。
 */
export const resolveGlobalBgColor = (globalConfig: GlobalColorSource | undefined | null): string => {
  if (!globalConfig) return DEFAULT_GLOBAL_BG_COLOR;

  const colors = globalConfig.colors;
  if (colors && typeof colors === 'object' && !Array.isArray(colors)) {
    const nested = normalizeColor(colors.bgColor) || normalizeColor(colors.pageBgColor);
    if (nested) return nested;
  }

  const flat = normalizeColor(globalConfig.bgColor) || normalizeColor(globalConfig.pageBgColor);
  return flat || DEFAULT_GLOBAL_BG_COLOR;
};
